import { type ApiResponse, estClient } from './estClient';

class BookingApi {
  async extendBooking({
    bookingId,
    days,
  }: {
    bookingId: Booking['id'];
    days: number;
  }): Promise<void> {
    await estClient.post<ApiResponse<{ booking: Booking; [key: string]: any }>>(
      `/api/booking/${bookingId}/extend_booking`,
      {
        body: {
          days,
        },
      },
    );
  }

  async cancelBooking(bookingId: Booking['id']): Promise<void> {
    await estClient.post<ApiResponse<{ booking: Booking; [key: string]: any }>>(
      `/api/booking/${bookingId}/cancel`,
    );
  }

  get STATUS() {
    return {
      ACTIVE: 1,
      CLOSED: 2,
      CANCELED: 3,
      EXPIRED: 4,
    } as const;
  }
}

export interface Booking {
  id: number;
  status: 1 | 2 | 3 | 4;
  opportunity_id: number;
  unit_id: number;

  /**
   * @example '2026-02-28 21:28:36.829400'
   */
  due_date: string;

  /**
   * @example '2026-03-14'
   */
  created_date: string;

  /**
   * @example '2026-02-28 21:28:36.829400'
   */
  created_at: string;
  created_by: string;

  /**
   * @example '2026-02-28 21:28:36.829400'
   */
  updated_at: string;
  updated_by: number;

  /**
   * @example '2026-02-28 21:28:36.829400'
   */
  closed_at: string | null;
  closed_by: number | null;
}

export const bookingApi = new BookingApi();
